export default {
    npiNumber: {
        type: 'prefilled',
        value: (appContext) => appContext.npiNumber,
        label: 'Provider NPI:',
        labelProps: {
            id: 'MEDCAL_RX_PROVIDER_NPI_LABEL'
        },
    },
    authNumber: {
        type: 'authNumber',
        required: true,
        label: 'Authorization Number:',
        disabled: context => context.fields.beneficiaryID.value
                                ||  context.fields.beneficiaryDOB.value
                                || context.fields.beneficiaryLastName.value,
        input: {
            placeholder: 'Authorization Number',
            inputProps: {
                id: 'MEDCAL_RX_AUTHORIZATION_NUMBER_VALUE',
                maxLength: 20,
                'data-testid':'InquiryAuthInput',
                'aria-label': 'authorization_number',
                name: 'authNumber',
            },
            FormHelperTextProps: {
                error: true,
                margin: 'dense'
            },
        },
        labelProps: {
            id: 'MEDCAL_RX_AUTHORIZATION_NUMBER_LABEL'
        },
    },
    beneficiaryID: {
        type: 'text',
        label: 'Member ID:',
        required: true,
        tooltip: (operation) =>  {
            if(operation === 'inquiry') {
                return `Please enter the beneficiary's Cardholder ID Number (CIN). This will be the first 9 characters of the Beneficiary Identification Card (BIC) number.
                If you have any issues and would like to speak to a representative please call the customer service center at 1-800-977-2273.`
            }
            return null
        },
        tooltipStyle: {
            fontSize: '0.85rem'
        },
        input: {
            // style: { textTransform: 'uppercase' }, // flagged by siteImprove for as a Q level compliance issue
            placeholder: 'Member ID',
            inputProps: {
                maxlength: 9,
            },
        },
        visible: context => context.operation === 'inquiry',
        disabled: context => context.authNumber || context.fields.beneficiaryDOB.value ||
                             context.fields.beneficiaryLastName.value
    },
    beneficiaryLastName: {
        type: 'text',
        label: 'Member Last Name:',
        required: true,
        input: {
            placeholder: 'Member Last Name',
            inputProps: {
                maxlength: 25,
            },
        },
        visible: context => context.operation === 'inquiry',
        disabled: context => context.authNumber || context.fields.beneficiaryID.value,
        onChange: (value, {setFields}) => setFields({beneficiaryLastName: value.toUpperCase()})
    },
    beneficiaryDOB: {
        type: 'date',
        label: 'Member DOB:',
        validations: ['lessThanToday'],
        required: true,
        input: {
            FormHelperTextProps: {
                error: true,
                margin: 'dense',
            },
        },
        maxDate: _ => new Date(),
        visible: context => context.operation === 'inquiry',
        disabled: (context) => {
            return context.authNumber || context.fields.beneficiaryID.value
        }
    },
    requestBeginDate: {
        label: 'PA Request Begin Date:',
        type: 'date',
        required: true,
        input: {
            FormHelperTextProps: {
                error: true,
                margin: 'dense',
            },
        },
        maxDate: (context) => {
            if(context){
                const endDate = context.fields.requestEndDate.value
                if(endDate){
                    return new Date(window.moment(endDate, 'MM/DD/YYYY').subtract(1, 'days'))
                }
            }
        },
        minDate: (context) => {
            if(context){
                const endDate = context.fields.requestEndDate.value
                if(endDate){
                    return new Date(window.moment(endDate, 'MM/DD/YYYY').subtract(365, 'days'))
                }
            }
        },
        helperText: 'PA Request Begin Date must be before and within 365 days of PA Request End Date',
        defaultValue: window.moment().subtract(364, 'days').format('MM/DD/YYYY'),
        visible: context => context.operation === 'inquiry' && !context.authNumber

    },
    requestEndDate: {
        label: 'PA Request End Date:',
        type: 'date',
        required: true,
        input: {
            FormHelperTextProps: {
                error: true,
                margin: 'dense',
            },
        },
        maxDate: (context) => {
            if(context){
                const beginDate = context.fields.requestBeginDate.value
                if(beginDate){
                    const max = new Date(window.moment(beginDate, 'MM/DD/YYYY').add(365, 'days'))
                    return max
                }
            }
        },
        minDate: (context) => {
            if(context){
                const beginDate = context.fields.requestBeginDate.value
                if(beginDate){
                    const min = new Date(window.moment(beginDate, 'MM/DD/YYYY').add(1, 'days'))
                    return min
                }
            }
        },
        helperText: 'PA Request End Date must be after and within 365 days of PA Request Begin Date',
        defaultValue: window.moment().add(1, 'days').format('MM/DD/YYYY'),
        visible: context => {
            return context.operation === 'inquiry' && !context.authNumber
        }
    },
}

export const defaultHelperTextProps = {style: {width: '28ch'}}

export const defaultInputProps = {
    variant: 'outlined',
    size: 'small',
    style: {width: '28ch'},
    inputProps: {'autocomplete': 'off'}
}

export const defaultLabelWrapper = {
    maxWidth: '300px',
    paddingTop: '1rem'
}

export const defaultHeaderWrapper = {
    maxWidth: 'fit-content'
}

export const defaultLabelProps = {
    style: {
        fontWeight: 'bold'
    }
}

export const defaultFieldDims = (operation) => ({
    xs: 12,
    lg: 8,
    xl: operation === 'inquiry' ? 6 : 9
})

export const fieldGroups = [
    ['npiNumber'],
    ['authNumber'],
    ['beneficiaryID'],
    ['beneficiaryLastName', 'beneficiaryDOB'],
    ['requestBeginDate', 'requestEndDate']
]
